<template>
  <div
    ref="refStay"
    class="stays-group"
    :id="localGroup.selectedStay.id"
    :rate-identifier="localGroup.selectedStay.id"
  >
    <div class="stays-group__countdown mb-3">
      <div class="w-100 stays-group__countdown__title mb-3">
        <div class="w-100 d-block d-sm-flex justify-content-between">
          <LargeText class="stays-group__title" testid="stay-group-title">{{
            localGroup.title
          }}</LargeText>
          <div class="stays-group__member" v-if="isMirrorMemberRate && getToggleSwitch">
            {{ translate('rdToggleRewardButton') }}
          </div>
          <div class="stays-group__member" v-else-if="isSingleMemberRate">
            {{ translate('rdToggleRewardButton') }}
          </div>
        </div>
        <Countdown
          v-if="localGroup.isDealOfTheDay()"
          class="stays-group__countdown-time ml-lg-4"
          :short="true"
          :expiryDate="localGroup.dealExpiryDate()"
        />
      </div>
      <SwitchType :tabSelected="tabSelected" :localGroup="localGroup" @change="toggleSwitch" />
    </div>
    <div>
      <rate-conditions
        :localGroup="localGroup"
        :isRefundable="isNonRrfundableRates"
        :tooltip="getTooltip || {}"
        :isRoomOnly="isRoomOnly"
      />
      <div class="rate-promo">
        <button
          id="stays-group-rate-button"
          data-testid="stays-group-rate-button"
          type="button"
          @click="$bvModal.show('stayDetails-' + localGroup.selectedStay.uuid)"
          class="btn mr-2 btn-link text-decoration-none"
          :class="MealsInfo ? 'mb-1' : ''"
        >
          <span class="link__text text-12 text-uppercase font-weight-bold">
            {{ translate('rdRateDetails') }}
          </span>
          <i class="xs rhg-font-icon--arrow-right"></i>
        </button>
        <Booster :stay="localGroup.selectedStay" showPromoLabel class="d-none d-lg-flex" />
      </div>
    </div>
    <div class="meal-price-section" :class="MealsInfo ? 'mt-n2' : ''">
      <StaysSection
        @mealsInfo="getMealsInfo"
        :group="localGroup"
        @activeStay="setActiveStay"
        :tabToSelect="tabSelected"
        :currentGroupPublicRates="
          localGroup.staysPublic && localGroup.staysPublic.map(stay => stay.id)
        "
        :currentGroupMemberRates="
          localGroup.staysMember && localGroup.staysMember.map(stay => stay.id)
        "
        @isRoomOnly="onIsRoomOnly"
        class="mb-4"
      />
      <Booster :stay="localGroup.selectedStay" showPromoLabel class="d-block d-md-flex d-lg-none" />
      <FromPriceButton
        :stay="localGroup.selectedStay"
        :localGroup="localGroup"
        :tabSelected="tabSelected"
        :modalTrigger="true"
        :hasCrowdLabel="true"
        :isDealOfTheDay="group.isDealOfTheDay()"
        :isLastRoomTab="isLastRoomTab"
        :currentRoom="currentRoom"
        :rooms="rooms"
        :room="room"
        showPromoLabel
        @roomSelected="handleRoomSelected"
      />
    </div>
    <StayDetailsModal
      v-if="localGroup.selectedStay.jsonForIntegrateWithApi"
      :undiscountedRate="false"
      :id="localGroup.selectedStay.uuid"
      :stay="localGroup.selectedStay.jsonForIntegrateWithApi"
      :isEcert="localGroup.selectedStay.eCertIsApplied"
      :hasTaxIncluded="localGroup.selectedStay.includesTaxes"
      :checkInTime="localGroup.selectedStay.checkInTime"
      :checkOutTime="localGroup.selectedStay.checkOutTime"
    />
  </div>
</template>
<script>
import Group from '@/multi-room-display/domain/Group'
import Stay from '@/multi-room-display/domain/Stay'
import LargeText from '@/multi-room-display/components/shared/LargeText'
import SwitchType from '@/multi-room-display/components/SwitchType'
import StaysSection from './StaysSection'
import FromPriceButton from '../shared/FromPriceButton'
import { Countdown } from 'rhg-vue-components'
import Room from '../../domain/Room'
import StayDetailsModal from '../modal/StayDetailsModal'
import { createNamespacedHelpers } from 'vuex'
import TabTypes from '@/domain/TabTypes'
import Booster from '@/multi-room-display/components/shared/Booster'
import rateConditions from '@/multi-room-display/components/shared/rateConditions'
const { mapState, mapMutations, mapGetters } = createNamespacedHelpers('multiRoomDisplay')

export default {
  name: 'StaysGroup',
  components: {
    LargeText,
    StaysSection,
    FromPriceButton,
    Countdown,
    StayDetailsModal,
    Booster,
    rateConditions,
    SwitchType
  },
  props: {
    group: {
      type: Group
    },
    defaultTab: {
      type: String
    },
    loading: {
      type: Boolean,
      defaultValue: false
    },
    disabled: {
      type: Boolean,
      defaultValue: false
    },
    loyaltyConsentAccepted: {
      type: Boolean
    },
    bookingStayInProgress: {
      type: Stay
    },
    isLastRoomTab: {
      type: Boolean
    },
    currentRoom: {
      type: Number
    },
    rooms: {
      type: Array
    },
    room: {
      type: Room
    }
  },
  data: () => ({
    localGroup: null,
    showPaywithPointTag: false,
    TabTypes: TabTypes,
    MealsInfo: null,
    activeTab: false,
    isRoomOnly: false,
    mealPlanSelected: null,
    rateCodeSelected: null
  }),
  created() {
    this.localGroup = this.group
  },
  mounted() {
    if (this.tabSelected !== TabTypes.MEMBER) {
      return
    }
    if (this.customer.isLogged && this.isMirrorMemberRate) {
      this.seToggleSwitchIsMemberRate()
    } else if (this.getNonMemberRate) {
      this.setTabSelected(TabTypes.PUBLIC)
      this.setToggleGroup(false)
    } else {
      this.seToggleSwitchIsMemberRate()
    }
  },

  watch: {
    group(updatedGroup) {
      const newSelectedStay = updatedGroup.findStayById(this.localGroup.selectedStay.id)
      this.localGroup = updatedGroup.setSelectedStay(newSelectedStay)
    }
  },
  methods: {
    ...mapMutations(['setToggleGroup', 'setTabSelected']),
    toggleSwitch(value) {
      this.activeTab = value
      this.setToggleGroup(this.activeTab)
      if (this.activeTab) {
        this.setTabSelected(TabTypes.MEMBER)
      } else {
        this.setTabSelected(TabTypes.PUBLIC)
      }
      this.$nextTick(() => {
        if (this.$refs.refStay.id === this.localGroup.selectedStay.id) {
          this.$refs.refStay.classList.add('sparkle')
          const cardRect = this.$refs.refStay.getBoundingClientRect()
          const cardTopInView = cardRect.top
          const scrollY = window.scrollY + cardTopInView - 250
          window.scrollTo({
            top: scrollY,
            behavior: 'auto'
          })
          setTimeout(() => {
            this.$refs.refStay.classList.remove('sparkle')
          }, 1000)
        }
      })
    },
    getMealsInfo(value) {
      this.MealsInfo = value
    },
    getAlignItemsFlex() {
      if (this.meals.length === 2) {
        return 'align-items-end'
      } else {
        return 'align-items-start'
      }
    },
    setActiveStay(stay) {
      this.localGroup = this.localGroup.setSelectedStay(stay)
      this.rateCodeSelected = this.localGroup.selectedStay.code
      this.mealPlanSelected = this.localGroup.selectedStay.mealPlan
      this.$emit('selectStay', stay)
    },
    seToggleSwitchIsMemberRate() {
      this.setTabSelected(TabTypes.MEMBER)
      this.setToggleGroup(true)
    },
    onIsRoomOnly(value) {
      this.isRoomOnly = value
    },
    handleRoomSelected(
      roomSelected,
      rates,
      code,
      mealPlan,
      rate,
      mealPlanName,
      rateName,
      dealOfTheDay
    ) {
      if (roomSelected) {
        this.$emit(
          'roomSelected',
          true,
          rates,
          code,
          mealPlan,
          rate,
          mealPlanName,
          rateName,
          dealOfTheDay
        )
      }
    }
  },
  computed: {
    ...mapState(['toggleGroup']),
    ...mapGetters(['hotel', 'customer', 'getToggleSwitch', 'getTabSelected', 'getNonMemberRate']),
    getTooltip() {
      return (
        this.isNonRrfundableRates &&
        this.hotel.nonRefundableRatesInfo.find(rate => rate.page === 'ROOM_DISPLAY')
      )
    },
    isNonRrfundableRates() {
      return this.hotel.showNonRefundableRatesInfo
    },
    isParamFacilitatorId() {
      return global.Utils.getURLParameter('facilitatorId')
    },
    isSingleMemberRate() {
      return this.localGroup.hasMemberRates() && !this.localGroup.hasPublicRate()
    },
    isMirrorMemberRate() {
      return this.localGroup?.hasMemberRates() && this.localGroup?.hasPublicRate()
    },
    tabSelected() {
      return this.getTabSelected
    }
  }
}
</script>
<style lang="scss" scoped>
.stays-group {
  background-color: white;
  padding: 2rem;
  margin-bottom: 0.7rem;
  &__member {
    color: #382246;
    font-weight: bold;
  }
  .meal-price-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 992px) {
      flex-direction: column;
    }
  }
  .rate-promo {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &:last-child {
    margin-bottom: 0;
    border-bottom-right-radius: 0.6rem;
    border-bottom-left-radius: 0.6rem;
  }

  &__title {
    font-weight: bold;
    margin-bottom: 1rem;
    @media (min-width: 992px) {
      margin-bottom: 0;
    }
  }

  &__conditions {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
    margin-bottom: 8px;
    @media (min-width: 992px) {
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  &__condition {
    margin-right: 1.5rem;
  }

  &__countdown {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media (min-width: 992px) {
      flex-direction: row;
      flex-wrap: wrap;
    }
    &__title {
      display: flex;
      @media (max-width: 992px) {
        display: grid;
        align-items: initial;
      }
    }
  }

  &__countdown-time {
    margin-bottom: 0.5rem;
  }
  .zeroOpacity {
    opacity: 0;
  }
}

@keyframes sparkle {
  0% {
    box-shadow: 0 0 5px rgba(200, 160, 255, 0.5);
  }
  50% {
    box-shadow: 0 0 20px rgba(200, 160, 255, 0.9);
  }
  100% {
    box-shadow: 0 0 5px rgba(200, 160, 255, 0.5);
  }
}

.sparkle {
  animation: sparkle 2s infinite;
}

html[dir='rtl'] {
  .stays-group {
    &__title {
      text-align: right;
    }
    &__member {
      text-align: right;
    }
    &__countdown-time {
      margin-left: 0 !important;
    }
  }
}
</style>
